import React from "react";
import { PartnerCard } from "./ui/partner-card";
import { Flex } from "@radix-ui/themes";
import { BlueField } from "./ui/blue-field";

export function Polpharma() {
  return (
    <PartnerCard
      logo={
        <img
          className="partner-logo"
          src="/Images/barometer/2025/massMediaLogos/polpharma-logo.jpg"
          alt="partner logo"
        />
      }
      heading="Експертний партнер"
    >
      <Flex direction="column" gap="5">
        <p>
          <BlueField>
            POLPHARMA – один з найбільших фармацевтичних польських
            виробників,{" "}
          </BlueField>
          який працює на ринку України понад 20 років
        </p>

        <p>
          Міжнародна фармацевтична група, лідер польського фармацевтичного ринку
          та{" "}
          <BlueField>
            один із найбільших виробників генеричних лікарських засобів у
            Центрально-Східній Європі.
          </BlueField>{" "}
          У портфелі продуктів групи POLPHARMA близько 600 лікарських препаратів
          і ще понад 200 перебувають у розробці
        </p>

        <p>
          Компанія була заснована у 1935 році, має потужні виробничі та
          науково-дослідні центри, а її продукція експортується до більш ніж 60
          країн світу
        </p>

        <BlueField>
          Входить до ТОР-20 світових виробників генеричних лікарських препаратів
        </BlueField>
      </Flex>
    </PartnerCard>
  );
}
